import * as React from 'react'
import { JSX } from 'react/jsx-runtime'

export function FileUpload(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      width={42}
      height={42}
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M24.2583 6.14705H6.28017C5.08815 6.14705 3.94495 6.62058 3.10206 7.46346C2.25917 8.30635 1.78564 9.44955 1.78564 10.6416V33.1142M1.78564 33.1142V37.6087C1.78564 38.8007 2.25917 39.9439 3.10206 40.7868C3.94495 41.6297 5.08815 42.1032 6.28017 42.1032H33.2473C34.4393 42.1032 35.5825 41.6297 36.4254 40.7868C37.2683 39.9439 37.7418 38.8007 37.7418 37.6087V28.6197M1.78564 33.1142L12.0916 22.8082C12.9344 21.9657 14.0774 21.4923 15.2692 21.4923C16.461 21.4923 17.604 21.9657 18.4468 22.8082L24.2583 28.6197M37.7418 19.6306V28.6197M37.7418 28.6197L34.1777 25.0555C33.3348 24.2129 32.1918 23.7396 31 23.7396C29.8083 23.7396 28.6653 24.2129 27.8224 25.0555L24.2583 28.6197M24.2583 28.6197L28.7528 33.1142M33.2473 6.14705H42.2363M37.7418 1.65253V10.6416M24.2583 15.1361H24.2807"
        stroke={props.color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
